/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.40.0-dev.20230609(60a087657e02fe7ae18c0ca205ea9ac5142adb9f)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.es", {
	"vs/base/common/platform": [
		"_",
	]
});